import { CircularProgress } from "@mui/material";
import React from "react";
import { clearAdminSession } from "@utils/adminAuth";

export function requireAuthentication(Component) {
    return class AuthenticatedComponent extends React.Component {
        constructor(props) {
            super(props);
            this.state = {data: null}
        }
        componentDidMount() {
            const sid = localStorage.getItem("sid");
            if (!sid) {
                window.location.replace("/login");
                return;
            }

            fetch(`/identity/sessions/verify`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${sid}`,
                },
            })
                .then((response) =>
                    response.json().then((data) => ({ status: response.status, data }))
                )
                .then(({ status, data }) => {
                    const sessionExpired =
                        status === 498 ||
                        data?.code === 498 ||
                        data?.message === "Session đã hết hiệu lực";

                    if (sessionExpired) {
                        clearAdminSession();
                        this.setState({ data: null });
                        window.location.replace("/login");
                        return;
                    }

                    if (data?.result && !data?.message) {
                        this.setState({ data });
                        return;
                    }

                    clearAdminSession();
                    this.setState({ data: null });
                    window.location.replace("/login");
                })
                .catch(() => {
                    clearAdminSession();
                    window.location.replace("/login");
                });
        }
        /**
         * Check if the user is authenticated, this.props.isAuthenticated
         * has to be set from your application logic (or use react-redux to retrieve it from global state).
         */
        /**
         * Render
         */
        render() {

            const loginErrorMessage = (
                <>
                    {localStorage.getItem("sid") ?
                    <CircularProgress/> :
                    <></>}
                </>
            );
            return (
                <div>
                    {/* { this.isAuthenticated === true ? <Component {...this.props} /> : loginErrorMessage } */}
                    { this.state.data?.result ? <Component {...this.props} /> : loginErrorMessage }
                    {/* <Component {...this.props}/> */}
                </div>
            );
        }
    };
}

export default requireAuthentication;